import { render, staticRenderFns } from "./layout-card.vue?vue&type=template&id=11b46626&scoped=true&"
var script = {}
import style0 from "./layout-card.vue?vue&type=style&index=0&id=11b46626&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b46626",
  null
  
)

export default component.exports